
import { Component } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { TransactionCash } from "@/api/api-order-service";
import piSelectTableData from "@/components/select-table-data/select-table-data.vue";
import topUp from "./components/topup.vue";
import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";
import i18n from "@/config/i18n";
@Component({
  components: {
    piSelectTableData,
    topUp
  }
})
export default class PiChargeOrderList extends mixins(tableMaxHeight) {
  numbe = "";
  private formInline: objAny = {
    globalPageIndex: 1,
    globalPageSize: 10,
    oprPkId: "",
    merchantPkId: "",
    startDate: "",
    endDate: "",
    orderNo: ""
  };
  private loading = true;
  win: objAny = window;
  private searchShow = true;
  private total = 0;
  chargeTimes: objAny = [];
  payTimes: objAny = [];

  private tableList: object[] = [];
  private tableColumns: object[] = [];
  private allTableData: object[] = [
    {
      title: i18n.t("cashTopUp.orderNo"),
      key: "orderNo",
      fixed: "left",
      minWidth: 200
    },
    {
      title: i18n.t("cashTopUp.topUpAmount"),
      key: "rechargeAmount",
      minWidth: 110
    },
    {
      title: i18n.t("cashTopUp.userName"),
      key: "fullName",
      minWidth: 110
    },
    {
      title: i18n.t("cashTopUp.phone"),
      key: "phoneNo",
      slot: "phoneNo",
      minWidth: 130
    },
    {
      title: i18n.t("cashTopUp.email"),
      key: "email",
      minWidth: 130
    },
    {
      title: i18n.t("cashTopUp.transactionTime"),
      key: "transactionTime",
      minWidth: 130
    }
  ];

  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public formDataNull(data: objAny): objAny {
    const json: objAny = {};
    for (const i in data) {
      if (data[i] !== "" && data[i] !== undefined) {
        json[i] = data[i];
      }
    }
    return json;
  }

  public chargeTimesChange(): void {
    this.getFormTime();
  }
  public getFormTime(): void {
    let startTime = "";
    let endTime = "";
    if (this.chargeTimes[0]) {
      startTime = this.$common.thisTimes(
        "yyyy-MM-dd",
        new Date(this.chargeTimes[0])
      );
      endTime = this.$common.thisTimes(
        "yyyy-MM-dd",
        new Date(this.chargeTimes[1])
      );
    }

    this.formInline.startDate = startTime;
    this.formInline.endDate = endTime;
    this.formInline.dateStr = startTime + "~" + endTime;
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const params = this.formDataNull(this.formInline);
    const ret = await TransactionCash(params);
    if (ret.status == this["$config"].apiStatus) {
      this.tableList = this["$common"].forTableList(ret.data);
      this.total = ret.total;
    }
    this.loading = false;
  }

  onSearch() {
    this.formInline.globalPageIndex = 1;
    this.exportCondition = Object.assign({}, this.formInline);
    this.getTableList();
  }

  showTopUp() {
    this.$refs.topupRef.show();
  }

  mounted() {
    this.$nextTick(() => {
      //如果路由有带电话参数，则取出来
      const date = this.$common.thisTimes("yyyy-MM");
      const endTime = this.$common.thisTimes("yyyy-MM-dd");
      const startTime = date + "-01";
      this.chargeTimes = [startTime, endTime];
      this.getFormTime();
      this.getTableList();
    });
  }
}
